import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import CustomerHome from './CustomerHome';
import AdminApp from './AdminApp';
import PlusSizes from './PlusSizes';
import CategoryPage from './CategoryPage';
import ProductDetail from './ProductDetail';
import LegalPage from './InfoPages';
import AgentPanel from './AgentPanel';
import DeliverPage from './DeliverPage';
import MyOrders from './MyOrders';
import MyTrialBag from './MyTrialBag';
import BottomNav from './BottomNav';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function ConditionalBottomNav() {
  const location = useLocation();
  if (
    location.pathname.startsWith('/admin') ||
    location.pathname.startsWith('/agent') ||
    location.pathname.startsWith('/deliver')
  ) return null;
  return <BottomNav />;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/plus-sizes" element={<PlusSizes />} />
        <Route path="/shop/:slug" element={<CategoryPage />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/privacy" element={<LegalPage />} />
        <Route path="/terms" element={<LegalPage />} />
        <Route path="/returns" element={<LegalPage />} />
        <Route path="/delivery" element={<LegalPage />} />
        <Route path="/agent" element={<AgentPanel />} />
        <Route path="/deliver/:bookingId" element={<DeliverPage />} />
        <Route path="/my-orders" element={<MyOrders />} />
        <Route path="/my-trial" element={<MyTrialBag />} />
        <Route path="/" element={<CustomerHome />} />
        <Route path="/admin" element={<AdminApp />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ConditionalBottomNav />
    </BrowserRouter>
  );
}

export default App;